import { apiEndPoint } from "./endPoint";

export type preDairyAnswerDataType = {
  affectGrid: {
    arousal: number;
    pleasantness: number;
  };
  eventValue: number;
  eventControllable: boolean;
  eventRelation: boolean;
};

export type postDairyAnswerDataType = {
  affectGrid: {
    arousal: number;
    pleasantness: number;
  };
  eventValue: number;
  satisfactionValue: number;
  noveltyValue: number;
};

export const putDairyAnswerData = async (
  userId: string,
  date: string,
  answer: preDairyAnswerDataType | postDairyAnswerDataType,
  token: string
) => {
  const url = `${apiEndPoint}/putDairyAnswerData`;

  const putData = {
    userId: userId,
    date: date,
    answer: answer,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(putData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
